import {observable, runInAction} from "mobx";
import {storageService} from "common/services";
import BaseUserStore from "./base/BaseUserStore";
import IUser from "common/interfaces/IUser";
import * as _ from "lodash";
import {NetworkFeatures} from "common/enums";
import {UserRole} from "@vidazoo/ui-framework";
import INetwork from "common/interfaces/INetwork";
import vidazooAppsAPI from "common/apis/vidazooAppsAPI";
import {sessionStore} from "./index";
import {User} from "@auth0/auth0-spa-js";

export default class CurrentUserStore extends BaseUserStore {

	@observable public apps: any[] = [];
	@observable public auth0User?: User;

	constructor() {
		super();
	}

	public getApps = async () => {
		try {
			const apps = await vidazooAppsAPI.getApps();
			runInAction(() => {
				this.apps = apps;
			});
		} catch (err) {
			runInAction(() => {
				this.apps = [];
			});
		}
	};

	public initialize(user: IUser, auth0User?: User) {
		super.initialize(user);
		this.auth0User = auth0User;
		storageService.initialize(this._id);
	}

	public isBelongToUser(userId: string): boolean {
		return this._id === userId || this.auth0User?.app_metadata.apps?.supply?.legacyId === userId;
	}

	public setNetwork = (network: INetwork) => {
		this.network = network;
	};
}
